// extracted by mini-css-extract-plugin
export default {"card":"styles_card__rhq92","card__img":"styles_card__img__KOcU2","card__title":"styles_card__title__fjG5E"};